class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    this.checkFilterGroups();
  }

  checkFilterGroups() {
    var filterGroups = this.querySelectorAll('.filter__list-group');

    if (filterGroups) {
      filterGroups.forEach((group) => {
        if (group.querySelectorAll('.filter__item').length == 0) {
          group.classList.add('hidden');
        } else {
          group.classList.remove('hidden');
        }
      });
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    searchParams.replace(/filter.v.availability=1/g, '');

    if (searchParams.indexOf('filter.p.m') > -1 || searchParams.indexOf('filter.v.option') > -1) {
      searchParams += '&filter.v.availability=1';
    }

    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();

    document.getElementById('ProductGridContainer').querySelector('.listing').classList.add('loading');

    const countContainer = document.getElementById('ProductCount');
    if (countContainer) {
      countContainer.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

        Wishlist.loadButtons();

        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);

    Wishlist.loadButtons();

    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll('.filter__group');

    facetDetailsElements.forEach((element) => {
      let id = element.id;
      let targetElement = document.getElementById(id);

      if (targetElement.hasAttribute('open')) {
        element.setAttribute('open', '');
      }

      targetElement.querySelector('.filter__group-menu').innerHTML = element.querySelector('.filter__group-menu').innerHTML;

      var filterGroups = targetElement.querySelectorAll('.filter__list-group');

      if (filterGroups) {
        filterGroups.forEach((group) => {
          if (group.querySelectorAll('.filter__item').length == 0) {
            group.remove();
          } else {
            group.classList.remove('hidden');
          }
        });
      }

      var filterList = targetElement.querySelector('.filter__group-menu .filter__list');

      if (filterList) {
        var isEmpty = filterList.innerHTML.trim() === '';

        if (isEmpty) {
          targetElement.parentElement.classList.add('hidden');
        } else {
          targetElement.parentElement.classList.remove('hidden');
        }
      }
    });

    const removeSource = parsedHTML.getElementById('FilterRemove');
    const removeTarget = document.getElementById('FilterRemove');

    if (removeSource && removeTarget) {
      removeTarget.innerHTML = removeSource.innerHTML;
    }

    const drawerRemoveSource = parsedHTML.getElementById('FilterDrawerRemove');
    const drawerRemoveTarget = document.getElementById('FilterDrawerRemove');

    if (drawerRemoveSource && drawerRemoveTarget) {
      drawerRemoveTarget.innerHTML = drawerRemoveSource.innerHTML;
    }
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    const viewAsToggle = document.querySelector('view-as-toggle');
    if (viewAsToggle) viewAsToggle.reload();

    const viewByToggle = document.querySelector('view-by-toggle');
    if (viewByToggle) viewByToggle.reload();

    //document.getElementById('product-grid').setAttribute('data-loaded', true);

    window.scrollTo(0, 0);
  }

  static renderProductCount(html) {
    //const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    //const container = document.getElementById('ProductCount');
    //container.innerHTML = count;
    //container.classList.remove('loading');

    const buttonCount = new DOMParser().parseFromString(html, 'text/html').getElementById('MenuDrawerApply').innerHTML;
    const documentButton = document.getElementById('MenuDrawerApply');
    documentButton.innerHTML = buttonCount;
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    /*
    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement.querySelectorAll('.facets__item.hidden').forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
    */
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const sortFilterForms = document.querySelectorAll('facet-filters-form form');

    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];

      sortFilterForms.forEach((form) => {
        forms.push(this.createSearchParams(form));
      });

      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);

    setTimeout(() => {
      document.querySelectorAll('.content-list [data-href]').forEach((element) => {
        element.classList.remove('link');
        element.classList.add('full-unstyled-link');

        element.setAttribute('href', element.getAttribute('data-href'));
      });
    }, 500);
  }
}

customElements.define('facet-remove', FacetRemove);

class ViewByToggle extends HTMLElement {
  constructor() {
    super();

    this.index = parseInt(this.dataset.index);
    this.optionsDesktop = this.dataset.options.split(',');
    this.optionsMobile = this.dataset.optionsMobile.split(',');

    this.button = this.querySelector('button');

    this.desktopText = this.querySelector('.facets-toggle__option--desktop');
    this.mobileText = this.querySelector('.facets-toggle__option--mobile');

    this.productGrid = document.querySelector('#product-grid');

    this.button.addEventListener('click', this.toggleView.bind(this));

    this.init();

    this.load();
  }

  reload() {
    this.productGrid = document.querySelector('#product-grid');

    this.init();
    this.unload();
    this.load();
  }

  init() {
    if (localStorage.getItem('viewBy')) {
      this.index = parseInt(localStorage.getItem('viewBy'));
    }
  }

  unload() {
    this.productGrid.classList.remove(`grid--${this.optionsDesktop[this.index]}-col-desktop`);
    this.productGrid.classList.remove(`grid--${this.optionsMobile[this.index]}-col-tablet-down`);
  }

  load() {
    this.productGrid.classList.add(`grid--${this.optionsDesktop[this.index]}-col-desktop`);
    this.productGrid.classList.add(`grid--${this.optionsMobile[this.index]}-col-tablet-down`);

    this.desktopText.innerHTML = this.optionsDesktop[this.index];
    this.mobileText.innerHTML = this.optionsMobile[this.index];

    this.productGrid.setAttribute('data-loaded', true);
  }

  toggleView(e) {
    e.preventDefault();

    this.unload();

    this.index = (this.index + 1) % this.optionsDesktop.length;

    this.load();

    this.save();
  }

  save() {
    localStorage.setItem('viewBy', this.index);
  }
}

customElements.define('view-by-toggle', ViewByToggle);

class ViewAsToggle extends HTMLElement {
  constructor() {
    super();

    this.index = parseInt(this.dataset.index);
    this.options = this.dataset.options.split(',');

    this.button = this.querySelector('button');

    this.text = this.querySelector('.facets-toggle__option');

    this.productGrid = document.querySelector('#product-grid');

    this.button.addEventListener('click', this.toggleView.bind(this));

    this.init();

    this.load();
  }

  reload() {
    this.productGrid = document.querySelector('#product-grid');

    this.init();

    this.unload();
    this.load();
  }

  getViewAs() {
    return this.options[this.index];
  }

  init() {
    if (localStorage.getItem('viewAs')) {
      this.index = parseInt(localStorage.getItem('viewAs'));
    }
  }

  unload() {
    const cards = this.productGrid.querySelectorAll('.card');

    cards.forEach((card) => {
      const media = card.querySelector(`.media--${this.options[this.index]}`);

      if (media) {
        media.classList.add('hidden');
      }
    });
  }

  load() {
    const cards = this.productGrid.querySelectorAll('.card');

    cards.forEach((card) => {
      const media = card.querySelector(`.media--${this.options[this.index]}`);

      if (media) {
        media.classList.remove('hidden');
      }
    });

    this.text.innerHTML = this.options[this.index];

    this.productGrid.setAttribute('data-loaded', true);
  }

  toggleView(e) {
    e.preventDefault();

    this.unload();

    this.index = (this.index + 1) % this.options.length;

    this.load();

    this.save();
  }

  save() {
    localStorage.setItem('viewAs', this.index);
  }
}

customElements.define('view-as-toggle', ViewAsToggle);
